import type { MailboxInfo } from "owa-client-types";
import { FeatureToAllowUserOverrideSettingIdMap, type OcpsPolicyFeature, } from "../store/schema/OutlookCloudPolicyTypes";
import { isPoliciesEnabledForAccount } from "../utils/isPoliciesEnabledForAccount";
import { getPolicyDataBySettingId } from "./getPolicyDataBySettingId";

/// <summary>
/// Determines if the user is allowed to change settings for a given feature based on the corresponding allowUserOverride policy.
/// If the allowUserOverride policy is not defined for the feature, it defaults to allowing user changes.
/// <param name="feature">The OCPS policy feature to check.</param>
/// <param name="mailboxInfo">The mailbox information of the user.</param>
/// <returns>True if the user is allowed to change settings for the feature; otherwise, false. If setting or policy data is undefined, it defaults to allowing user changes.</returns>
/// </summary>
export function isUserAllowedToChangeSettings(feature: OcpsPolicyFeature, mailboxInfo: MailboxInfo): boolean {
    if (!isPoliciesEnabledForAccount(mailboxInfo)) {
        return true;
    }
    
    const allowUserOverrideSettingId = FeatureToAllowUserOverrideSettingIdMap[feature];
    if (!!allowUserOverrideSettingId) {
        const policyData = getPolicyDataBySettingId(mailboxInfo, allowUserOverrideSettingId);
        return policyData ? policyData.value === "1" : true;
    }
    
    // If there is no specific allowUserOverride setting for the feature, default to allowing user changes
    return true;
}
